// Matches GraphicAssets.Placeholder; the page/component CSS supplies the artwork.
export const graphicPlaceholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
